// Per-device toggle for showing the patient's check-in note on the welcome
// display. Chosen on-screen via the doctor control panel and persisted to
// localStorage so it survives reloads on that display. Off by default — the
// note only surfaces when a clinic opts in on a given kiosk.

const STORAGE_KEY = "dc.welcomeCheckinNote";

export const DEFAULT_SHOW = false;

// Coerce any stored/incoming value to a boolean, falling back to the default
// for anything missing or unrecognized.
export function normalizeShow(raw) {
  return typeof raw === "boolean" ? raw : DEFAULT_SHOW;
}

export function loadShowCheckinNote() {
  try {
    return normalizeShow(JSON.parse(localStorage.getItem(STORAGE_KEY)));
  } catch (e) {
    return DEFAULT_SHOW;
  }
}

export function saveShowCheckinNote(value) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(normalizeShow(value)));
  } catch (e) {
    /* ignore quota/availability errors */
  }
}
